
export const forms = {
  // 个案帮扶 --综合查询
  getFormData(formData, extend, treeData) {
    const data = [
      {
        type: 'input',
        label: '申请人姓名',
        col: '8',
        id: 'need_help_person_name',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'input',
        label: '身份证号',
        col: '8',
        id: 'need_help_person_number_id',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        mode: 'multiple',
        label: '状态',
        col: '8',
        id: 'processBaseStatusList',
        defaultValue: [],
        options: [
          {
            label: '退回（申请中）',
            value: 'ReturnDraft'
          },
          {
            label: '终止',
            value: 'Termination'
          },
          {
            label: '待审批（街镇）',
            value: 'Approval1'
          },
          {
            label: '待审批（区级）',
            value: 'Approval2'
          },
          // {
          //   label: '待发放',
          //   value: 'Finish'
          // },
          {
            label: '待发放',
            value: 'Finish'
          },
          {
            label: '已完成',
            value: 'Finished'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'input',
        label: '帮扶金额',
        col: '5',
        placeholder: '最小金额',
        id: 'minFunds',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: 'text',
      //   label: '~',
      //   col: '1',
      //   id: 'fuhao',
      //   layout: {
      //     labelCol: '10'
      //   }
      // },
      {
        type: 'text',
        label: '~',
        col: '1',
        defaultValue: '~',
        align: 'center',
        id: 'idCard',
        layout: {
          labelCol: '1px'
        }
      },
      {
        type: 'input',
        label: '',
        col: '2',
        placeholder: '最大金额',
        id: 'maxFunds',
        layout: {
          labelCol: '0'
        }
      },
      {
        type: 'select',
        label: '帮扶类别',
        mode: 'multiple',
        col: '8',
        id: 'examineFormTypeList',
        defaultValue: [],
        options: [
          {
            label: '因病帮扶',
            value: '因病帮扶'
          },
          {
            label: '因残帮扶',
            value: '因残帮扶'
          },
          {
            label: '突发事件',
            value: '突发事件'
          },
          {
            label: '教育帮扶',
            value: '教育帮扶'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        label: '年龄结构',
        mode: 'multiple',
        col: '8',
        id: 'ageStructureList',
        defaultValue: [],
        options: [
          {
            label: '未成年',
            value: '未成年'
          },
          {
            label: '成年',
            value: '成年'
          },
          {
            label: '老年',
            value: '老年'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: 'select',
      //   label: '所属区域',
      //   col: '8',
      //   id: 'municipalTreeIdList',
      //   options: store.getters.areaList,
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: 'treeSelect',
        label: '所属区域',
        col: '8',
        treeData: treeData,
        id: 'municipalTreeIdList',
        defaultValue: [],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'rangePicker',
        label: '申请日期',
        format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
        col: '8',
        id: 'shenqingDate',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'rangePicker',
        label: '发放日期',
        format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
        col: '8',
        id: 'fafangDate',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        label: '家庭类别',
        mode: 'multiple',
        defaultValue: formData.povertyTypeList,
        options: [
          {
            label: '低保',
            value: '低保'
          },
          {
            label: '低收入',
            value: '低收入'
            // disabled: true
          },
          {
            label: '因病支出型',
            value: '因病支出型'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        col: '8',
        id: 'povertyTypeList',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: 'input',
      //   label: '项目负责单位',
      //   col: '7',
      //   id: 'unit',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: 'children',
        name: 'button',
        col: '24'
      }
    ]
    return data
  },
  // 项目帮扶 --综合查询
  getActiveData(kaizhanquyuTreeData, that) {
    const data = [
      // {
      //   type: 'rangePicker',
      //   label: '日期',
      //   format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
      //   // defaultValue: formData.name,
      //   col: '7',
      //   id: 'date',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: 'input',
        label: '项目名称',
        col: '8',
        id: 'processBaseTitle',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'treeSelect',
        label: '开展区域',
        col: '8',
        treeData: kaizhanquyuTreeData,
        id: 'municipalTreeIdList',
        defaultValue: [],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        mode: 'multiple',
        label: '项目发起方',
        col: '8',
        id: 'projectInitiatorList',
        defaultValue: [],
        options: that.getFaqifangArrData(),
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'rangePicker',
        label: '启动日期',
        format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
        col: '8',
        id: 'qidongDate',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        mode: 'multiple',
        label: '项目状态',
        col: '8',
        id: 'processBaseStatusList',
        defaultValue: [],
        options: [
          {
            label: '待申报',
            value: '1'
          },
          {
            label: '待复核',
            value: '2'
          },
          {
            label: '执行中',
            value: '3'
          },
          {
            label: '结项',
            value: '4'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        mode: 'multiple',
        label: '帮扶类别',
        col: '8',
        id: 'helpTypeList',
        defaultValue: [],
        options: [
          {
            label: '节日',
            value: '节日'
          },
          {
            label: '助学',
            value: '助学'
          },
          {
            label: '助困',
            value: '助困'
          },
          {
            label: '元旦春节帮困',
            value: '元旦春节帮困'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        label: '项目类型',
        col: '8',
        id: 'projectCategory',
        options: [
          {
            label: '资金类',
            value: 'projectFund'
          },
          {
            label: '服务类',
            value: 'projectActivity'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'children',
        name: 'button',
        col: '24'
      }
    ]
    return data
  },
  // 帮扶对象 --综合查询
  getPeopleData(formData, extend) {
    const data = [
      {
        type: 'input',
        label: '姓名',
        col: '8',
        id: 'name',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'input',
        label: '身份证号',
        // onChange: extend.numberChange,
        col: '8',
        rules: [
          {
            validator: extend.checkIdCard
          }
        ],
        id: 'idCard',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        mode: 'multiple',
        label: '家庭类别',
        col: '8',
        id: 'povertyTypeList',
        defaultValue: [],
        options: [
          {
            label: '低保',
            value: '低保'
          },
          {
            label: '低收入',
            value: '低收入'
            // disabled: true
          },
          {
            label: '因病支出型',
            value: '因病支出型'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        mode: 'multiple',
        label: '年龄结构',
        col: '8',
        id: 'structureList',
        defaultValue: [],
        options: [
          {
            label: '未成年',
            value: '1'
          },
          {
            label: '成年',
            value: '2'
          },
          {
            label: '老年',
            value: '3'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        mode: 'multiple',
        label: '帮扶形式',
        col: '8',
        id: 'configTypeList',
        defaultValue: [],
        options: [
          {
            label: '个案帮扶',
            value: 'individualCase'
          },
          {
            label: '项目帮扶（资金类）',
            value: 'projectFund'
          },
          {
            label: '项目帮扶（服务类）',
            value: 'projectActivity'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: 'select',
      //   label: '帮扶类别',
      //   col: '8',
      //   id: 'process_base_status1',
      //   options: [
      //     {
      //       label: '因病帮扶',
      //       value: '因病帮扶'
      //     },
      //     {
      //       label: '因残帮扶',
      //       value: '因残帮扶'
      //     },
      //     {
      //       label: '突发事件',
      //       value: '突发事件'
      //     },
      //     {
      //       label: '教育帮扶',
      //       value: '教育帮扶'
      //     },
      //     {
      //       label: '其他',
      //       value: '其他'
      //     }
      //   ],
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: 'children',
        name: 'button',
        col: '24'
      }
    ]
    return data
  }
}
